import React from "react";
import PropTypes from "prop-types";

// HeadlineKpiCard — a large headline-metric tile: an uppercase label, a big
// value, and an optional sub line (toned). This is the "big number, no status
// dot" style used above the cost-analyzer chart (AnalyzerKpiStrip) and, so it
// reads identically, the AI usage monitor's HealthStrip. Distinct from the
// compact dot-style KpiCard/StatTile. Presentational; layout (flex-1 / grid
// cell) is the parent's job via `className`. An empty sub still reserves a line
// so cards in a row keep equal heights.
export default function HeadlineKpiCard({ label, value, sub, subTone, className = "" }) {
  return (
    <div className={`rounded-card border border-card-bd bg-card p-4 ${className}`}>
      <div className="text-[11px] font-semibold uppercase tracking-[0.04em] text-text-3">{label}</div>
      <div className="mt-1.5 text-[26px] font-semibold leading-[32px] tabular-nums text-text">{value}</div>
      {sub ? (
        <div className={`mt-1 text-[13px] tabular-nums ${subTone || "text-text-3"}`}>{sub}</div>
      ) : (
        <div className="mt-1 text-[13px]">&nbsp;</div>
      )}
    </div>
  );
}

HeadlineKpiCard.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  sub: PropTypes.node,
  subTone: PropTypes.string,
  className: PropTypes.string,
};
